import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'satyam', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hello, my name is',
  name: 'Satyam',
  subtitle: 'A Student interested in Web Development ',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'dp.jpg',
  paragraphOne:
    'I am an undergraduate student persuing Computer Science and Engineering at SRM IST.',
  paragraphTwo:
    'I am intersted in creating Web applications and I am familiar with both Backend and Frontend Development. ',
  paragraphThree: 'I am currently learning to develop sites with the help of React library.',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'zariya.png',
    title: 'Zariya',
    info: 'Zariya is a Udemy clone site which provides an E-learning MarketPlace for its users Where the payments are managed by Stripe. ',
    info2:
      'The application has a robust backend and also uses various AWS services for Email, image and video storage. Password management and security is done with help of salting and hashing and encryption using bcrypt.',
    url: '',
    repo: 'https://github.com/satyam720/Zariya', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'clothZen.png',
    title: 'clothZen',
    info: 'ClothZen is an E-commerce website which allows online shopping of cloths.',
    info2:
      'The application uses firebase technology for database management and authorisation of users, Uses libaries like react and redux for state management and stripe to handle payments, and much more.',
    url: 'https://clothzen-live.herokuapp.com/',
    repo: 'https://github.com/satyam720/ClothZen', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'keeper.png',
    title: 'keeper app',
    info: 'It is a simple Note keeping app with a simple UI.',
    info2:
      'It allows users to create notes, add more notes and delete them as they like, and built with react.',
    url: 'https://satyam720.github.io/KeeperApp/',
    repo: 'https://github.com/satyam720/KeeperApp', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'psatyam1618@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/Satyam0_7',
    },

    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/satyam-pandey-8636001b0/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/satyam720',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
